module.exports = __webpack_public_path__ + "images/emoji/church.88e75b2bc846bb969d0a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/church.png
// module id = W5mr
// module chunks = 14